var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "input-unit",
        attrs: { "data-validate": "", "data-model": "countryId" }
      },
      [
        _c(
          "select",
          {
            staticClass: "custom-select",
            attrs: { id: "country-id-select" + _vm._uid },
            domProps: { value: _vm.selectedCountryId },
            on: {
              change: function($event) {
                return _vm.countryChanged($event.target.value)
              }
            }
          },
          _vm._l(_vm.countryList, function(country) {
            return _c(
              "option",
              {
                key: country.id,
                domProps: {
                  value: country.id,
                  selected: country.id === _vm.selectedCountryId
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(country.currLangName) +
                    "\n                "
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "label",
          { attrs: { for: "country-id-select" + _vm._uid } },
          [
            _vm.selectedCountryId == 12
              ? [_vm._v("Country")]
              : [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.headerCountry"))
                  )
                ]
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }